module.exports = __webpack_public_path__ + "img/127-fish.bd3cd9f.jpg";